import { CANCELLATION_REASONS } from './constants'
import LabeledSelect from '../../../components/selects/LabeledSelect'

const CancelOrder = ({modalData, setModalData}) => {
  return (
    <div className="flex flex-col space-y-4">
      <div>Please provide some reason for discarding the order</div>
      <LabeledSelect
        placeholder="Cancellation Reason"
        onChange={(reason) => {
          setModalData({reason: reason.value}) 
        }}
        options={CANCELLATION_REASONS}
        getOptionValue={(option) => option.value}
        getOptionLabel={(option) => option.label}
        value={CANCELLATION_REASONS.find((reason) => reason.value === modalData.reason)}
      />
    </div>
  )
}

export default CancelOrder
